
import { PropType, defineComponent } from 'vue';
import { toRussianLocaleDateTimeTzFromIso } from '@packages/toolbox/dist/utils/datetime';
import { NNotification } from 'SharedDir/declarations/notification';
import { useDeviceSize } from 'SharedDir/common/composables/useDeviceSize';

export default defineComponent({
  name: 'NotificationCard',
  props: {
    notification: {
      type: Object as PropType<NNotification.Notification>,
      required: true,
    },
    isColumnOrientation: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const {
      isMobile,
    } = useDeviceSize();
    const dateSendAt = (item: { sentAt?: string | null }) => {
      const sendAtRaw = item?.sentAt ?? '';
      const sendAt = toRussianLocaleDateTimeTzFromIso(sendAtRaw);

      return sendAt;
    };

    return { dateSendAt, isMobile };
  },
});
